module.exports = __webpack_public_path__ + "static/media/city-id-icon.fee7033c.svg";